import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from '../../atoms/Skeleton';
import { ProductCardSkeleton } from '../ProductCard';

/* BROWSE SKELETONS — the shape of the rail, the toolbar and the grid.

   The rail gets one too: a full grid beside an empty sidebar reads as a store
   with no filters rather than a page still loading, and the facets and products
   arrive from two different calls.

   The shapes are the real ones — each group is `.br-grp`'s 14px padding and
   hairline — so the rail does not jump when the facets land. */

export function RailSkeleton({ groups }) {
  return (
    <div aria-hidden="true">
      {/* The search field, at `.br-search`'s height plus its 18px gap. */}
      <div className="br-search"><Skeleton w="100%" h={38} /></div>

      {[...Array(groups)].map((_, i) => (
        <div className="br-grp" key={i}>
          <div className="br-gh">
            <Skeleton w={i % 2 ? 84 : 110} h={13} />
            <Skeleton w={15} h={15} />
          </div>
          {/* Only the first group is open by default, like the real rail. */}
          {i === 0 && (
            <div style={{ display: 'block', paddingTop: 11 }}>
              {[...Array(5)].map((__, r) => (
                <div className="br-opt" key={r}>
                  <Skeleton w={15} h={15} />
                  <Skeleton w={`${52 + ((r * 13) % 34)}%`} h={12} />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

RailSkeleton.propTypes = { groups: PropTypes.number };
RailSkeleton.defaultProps = { groups: 5 };

export function GridSkeleton({ count }) {
  return (
    <>
      {[...Array(count)].map((_, i) => <ProductCardSkeleton key={i} />)}
    </>
  );
}

GridSkeleton.propTypes = { count: PropTypes.number };
GridSkeleton.defaultProps = { count: 8 };

export default { RailSkeleton, GridSkeleton };
